"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoicePageSize = exports.PaymentPageSize = exports.NoticePageSize = exports.LitigationPageSize = exports.AccountPageSize = exports.PermitApplicationPageSize = void 0;
exports.PermitApplicationPageSize = 15;
exports.AccountPageSize = 50;
exports.LitigationPageSize = 10;
exports.NoticePageSize = 10;
exports.PaymentPageSize = 25;
exports.InvoicePageSize = 10;
